module.exports = __webpack_public_path__ + "static/media/puzzle04.38262312.png";